export const GENERATE_DERIVE = "GENERATE_DERIVE";
export const GENERATE_DERIVE_FAILURE = "GENERATE_DERIVE_FAILURE";
export const GENERATE_DERIVE_SUCCESS = "GENERATE_DERIVE_SUCCESS";

export const GET_PLAYER_1_CHART_STATS = " GET_PLAYER_1_CHART_STATS";
export const GET_PLAYER_2_CHART_STATS = " GET_PLAYER_2_CHART_STATS";
